/*eslint-disable*/
import React from 'react'
import { HashLink as Link } from 'react-router-hash-link'
import { useNavigate} from 'react-router-dom'
import { List, ListItem, Typography } from '@material-ui/core'
import { useNavigation } from '../../hook/Context/NavigationContext'

import { makeStyles } from '@material-ui/core/styles'
import styles from '../../styles/components/Header/headerLinksStyle'
import opensea from '../../assets/images/OpenSea.svg'
import twitter from '../../assets/images/Twitter.svg'

const useStyles = makeStyles(styles)

const HeaderLinks = () => {
  const classes = useStyles()
  const navigate = useNavigate()

  // context variables
  const { navigation, setNavigation } = useNavigation()

  // handlers
  const handleGotoNav = path => {
    setNavigation(path)
    navigate(path)
  }

  return (
    <List className={classes.list}>
      <ListItem className={classes.listItem}>
        <a href="https://twitter.com/HappySlothsNFT">
          <img src={twitter} className={classes.socialAvatar} />
        </a>
      </ListItem>
      <ListItem className={classes.listItem}>
        <a href="https://opensea.com">
          <img src={opensea} className={classes.socialAvatar} />
        </a>
      </ListItem>
    </List>
  )
}

export default HeaderLinks